import React from 'react';

import styles from './FormButton.module.css';

const FormButton = ({ children, submitting, submittingText, className }) => (
  <button
    type="submit"
    className={`${styles.submitButton} ${className} btn btn-success btn-lg`}
    disabled={submitting}
  >
    {submitting ? submittingText : children}
  </button>
);

FormButton.defaultProps = {
  className: ''
}

export default FormButton;
